export const IconNotFound = () => (
  <svg viewBox="0 0 425 427" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2508_19648)">
      <rect
        x="245.06"
        y="55.3418"
        width="176.537"
        height="396.065"
        rx="88.2685"
        transform="rotate(45 245.06 55.3418)"
        fill="#2657ED"
      />
      <rect
        x="335.399"
        y="37"
        width="176.537"
        height="396.065"
        rx="88.2685"
        transform="rotate(45 335.399 37)"
        fill="#601E82"
      />
      <g opacity="0.5">
        <circle
          cx="311.228"
          cy="77.3333"
          r="1.91508"
          transform="rotate(90 311.228 77.3333)"
          fill="#601E82"
        />
        <circle
          cx="289.889"
          cy="77.3333"
          r="1.91508"
          transform="rotate(90 289.889 77.3333)"
          fill="#601E82"
        />
        <circle
          cx="311.228"
          cy="162.693"
          r="1.91508"
          transform="rotate(90 311.228 162.693)"
          fill="#601E82"
        />
        <circle
          cx="289.889"
          cy="162.693"
          r="1.91508"
          transform="rotate(90 289.889 162.693)"
          fill="#601E82"
        />
        <circle
          cx="311.228"
          cy="120.013"
          r="1.91508"
          transform="rotate(90 311.228 120.013)"
          fill="#601E82"
        />
        <circle
          cx="289.889"
          cy="120.013"
          r="1.91508"
          transform="rotate(90 289.889 120.013)"
          fill="#601E82"
        />
        <circle
          cx="311.228"
          cy="205.372"
          r="1.91508"
          transform="rotate(90 311.228 205.372)"
          fill="#601E82"
        />
        <circle
          cx="289.889"
          cy="205.372"
          r="1.91508"
          transform="rotate(90 289.889 205.372)"
          fill="#601E82"
        />
        <circle
          cx="311.228"
          cy="98.6739"
          r="1.91508"
          transform="rotate(90 311.228 98.6739)"
          fill="#601E82"
        />
        <circle
          cx="289.889"
          cy="98.6736"
          r="1.91508"
          transform="rotate(90 289.889 98.6736)"
          fill="#601E82"
        />
        <circle
          cx="311.228"
          cy="184.032"
          r="1.91508"
          transform="rotate(90 311.228 184.032)"
          fill="#601E82"
        />
        <circle
          cx="289.889"
          cy="184.032"
          r="1.91508"
          transform="rotate(90 289.889 184.032)"
          fill="#601E82"
        />
        <circle
          cx="311.228"
          cy="141.352"
          r="1.91508"
          transform="rotate(90 311.228 141.352)"
          fill="#601E82"
        />
        <circle
          cx="289.889"
          cy="141.352"
          r="1.91508"
          transform="rotate(90 289.889 141.352)"
          fill="#601E82"
        />
        <circle
          cx="311.228"
          cy="226.71"
          r="1.91508"
          transform="rotate(90 311.228 226.71)"
          fill="#601E82"
        />
        <circle
          cx="289.889"
          cy="226.71"
          r="1.91508"
          transform="rotate(90 289.889 226.71)"
          fill="#601E82"
        />
        <circle
          cx="268.549"
          cy="77.3335"
          r="1.91508"
          transform="rotate(90 268.549 77.3335)"
          fill="#601E82"
        />
        <circle
          cx="247.209"
          cy="77.3335"
          r="1.91508"
          transform="rotate(90 247.209 77.3335)"
          fill="#601E82"
        />
        <circle
          cx="268.549"
          cy="162.693"
          r="1.91508"
          transform="rotate(90 268.549 162.693)"
          fill="#601E82"
        />
        <circle
          cx="247.209"
          cy="162.693"
          r="1.91508"
          transform="rotate(90 247.209 162.693)"
          fill="#601E82"
        />
        <circle
          cx="268.549"
          cy="120.013"
          r="1.91508"
          transform="rotate(90 268.549 120.013)"
          fill="#601E82"
        />
        <circle
          cx="247.209"
          cy="120.013"
          r="1.91508"
          transform="rotate(90 247.209 120.013)"
          fill="#601E82"
        />
        <circle
          cx="268.549"
          cy="205.372"
          r="1.91508"
          transform="rotate(90 268.549 205.372)"
          fill="#601E82"
        />
        <circle
          cx="247.209"
          cy="205.373"
          r="1.91508"
          transform="rotate(90 247.209 205.373)"
          fill="#601E82"
        />
        <circle
          cx="268.549"
          cy="98.6739"
          r="1.91508"
          transform="rotate(90 268.549 98.6739)"
          fill="#601E82"
        />
        <circle
          cx="247.209"
          cy="98.6739"
          r="1.91508"
          transform="rotate(90 247.209 98.6739)"
          fill="#601E82"
        />
        <circle
          cx="268.549"
          cy="184.032"
          r="1.91508"
          transform="rotate(90 268.549 184.032)"
          fill="#601E82"
        />
        <circle
          cx="247.209"
          cy="184.032"
          r="1.91508"
          transform="rotate(90 247.209 184.032)"
          fill="#601E82"
        />
        <circle
          cx="268.549"
          cy="141.352"
          r="1.91508"
          transform="rotate(90 268.549 141.352)"
          fill="#601E82"
        />
        <circle
          cx="247.209"
          cy="141.352"
          r="1.91508"
          transform="rotate(90 247.209 141.352)"
          fill="#601E82"
        />
        <circle
          cx="268.549"
          cy="226.71"
          r="1.91508"
          transform="rotate(90 268.549 226.71)"
          fill="#601E82"
        />
        <circle
          cx="247.209"
          cy="226.71"
          r="1.91508"
          transform="rotate(90 247.209 226.71)"
          fill="#601E82"
        />
        <circle
          cx="225.864"
          cy="77.3333"
          r="1.91508"
          transform="rotate(90 225.864 77.3333)"
          fill="#601E82"
        />
        <circle
          cx="204.522"
          cy="77.3333"
          r="1.91508"
          transform="rotate(90 204.522 77.3333)"
          fill="#601E82"
        />
        <circle
          cx="225.864"
          cy="162.693"
          r="1.91508"
          transform="rotate(90 225.864 162.693)"
          fill="#601E82"
        />
        <circle
          cx="204.522"
          cy="162.693"
          r="1.91508"
          transform="rotate(90 204.522 162.693)"
          fill="#601E82"
        />
        <circle
          cx="225.864"
          cy="120.013"
          r="1.91508"
          transform="rotate(90 225.864 120.013)"
          fill="#601E82"
        />
        <circle
          cx="204.522"
          cy="120.013"
          r="1.91508"
          transform="rotate(90 204.522 120.013)"
          fill="#601E82"
        />
        <circle
          cx="225.864"
          cy="205.372"
          r="1.91508"
          transform="rotate(90 225.864 205.372)"
          fill="#601E82"
        />
        <circle
          cx="204.522"
          cy="205.372"
          r="1.91508"
          transform="rotate(90 204.522 205.372)"
          fill="#601E82"
        />
        <circle
          cx="225.864"
          cy="98.6739"
          r="1.91508"
          transform="rotate(90 225.864 98.6739)"
          fill="#601E82"
        />
        <circle
          cx="204.522"
          cy="98.6739"
          r="1.91508"
          transform="rotate(90 204.522 98.6739)"
          fill="#601E82"
        />
        <circle
          cx="225.864"
          cy="184.032"
          r="1.91508"
          transform="rotate(90 225.864 184.032)"
          fill="#601E82"
        />
        <circle
          cx="204.522"
          cy="184.032"
          r="1.91508"
          transform="rotate(90 204.522 184.032)"
          fill="#601E82"
        />
        <circle
          cx="225.864"
          cy="141.352"
          r="1.91508"
          transform="rotate(90 225.864 141.352)"
          fill="#601E82"
        />
        <circle
          cx="204.522"
          cy="141.352"
          r="1.91508"
          transform="rotate(90 204.522 141.352)"
          fill="#601E82"
        />
        <circle
          cx="225.864"
          cy="226.71"
          r="1.91508"
          transform="rotate(90 225.864 226.71)"
          fill="#601E82"
        />
        <circle
          cx="204.522"
          cy="226.71"
          r="1.91508"
          transform="rotate(90 204.522 226.71)"
          fill="#601E82"
        />
        <circle
          cx="183.186"
          cy="77.3335"
          r="1.91508"
          transform="rotate(90 183.186 77.3335)"
          fill="#601E82"
        />
        <circle
          cx="161.848"
          cy="77.3333"
          r="1.91508"
          transform="rotate(90 161.848 77.3333)"
          fill="#601E82"
        />
        <circle
          cx="183.186"
          cy="162.693"
          r="1.91508"
          transform="rotate(90 183.186 162.693)"
          fill="#601E82"
        />
        <circle
          cx="161.848"
          cy="162.693"
          r="1.91508"
          transform="rotate(90 161.848 162.693)"
          fill="#601E82"
        />
        <circle
          cx="183.186"
          cy="120.013"
          r="1.91508"
          transform="rotate(90 183.186 120.013)"
          fill="#601E82"
        />
        <circle
          cx="161.848"
          cy="120.013"
          r="1.91508"
          transform="rotate(90 161.848 120.013)"
          fill="#601E82"
        />
        <circle
          cx="183.186"
          cy="205.373"
          r="1.91508"
          transform="rotate(90 183.186 205.373)"
          fill="#601E82"
        />
        <circle
          cx="161.848"
          cy="205.373"
          r="1.91508"
          transform="rotate(90 161.848 205.373)"
          fill="#601E82"
        />
        <circle
          cx="183.186"
          cy="98.6741"
          r="1.91508"
          transform="rotate(90 183.186 98.6741)"
          fill="#601E82"
        />
        <circle
          cx="161.848"
          cy="98.6741"
          r="1.91508"
          transform="rotate(90 161.848 98.6741)"
          fill="#601E82"
        />
        <circle
          cx="183.186"
          cy="184.032"
          r="1.91508"
          transform="rotate(90 183.186 184.032)"
          fill="#601E82"
        />
        <circle
          cx="161.848"
          cy="184.032"
          r="1.91508"
          transform="rotate(90 161.848 184.032)"
          fill="#601E82"
        />
        <circle
          cx="183.186"
          cy="141.353"
          r="1.91508"
          transform="rotate(90 183.186 141.353)"
          fill="#601E82"
        />
        <circle
          cx="161.848"
          cy="141.353"
          r="1.91508"
          transform="rotate(90 161.848 141.353)"
          fill="#601E82"
        />
        <circle
          cx="183.186"
          cy="226.71"
          r="1.91508"
          transform="rotate(90 183.186 226.71)"
          fill="#601E82"
        />
        <circle
          cx="161.848"
          cy="226.71"
          r="1.91508"
          transform="rotate(90 161.848 226.71)"
          fill="#601E82"
        />
      </g>
      <g opacity="0.5">
        <circle
          cx="138.033"
          cy="78.1665"
          r="1.91508"
          transform="rotate(90 138.033 78.1665)"
          fill="#601E82"
        />
        <circle
          cx="116.694"
          cy="78.1665"
          r="1.91508"
          transform="rotate(90 116.694 78.1665)"
          fill="#601E82"
        />
        <circle
          cx="138.033"
          cy="163.525"
          r="1.91508"
          transform="rotate(90 138.033 163.525)"
          fill="#601E82"
        />
        <circle
          cx="116.694"
          cy="163.525"
          r="1.91508"
          transform="rotate(90 116.694 163.525)"
          fill="#601E82"
        />
        <circle
          cx="138.033"
          cy="120.845"
          r="1.91508"
          transform="rotate(90 138.033 120.845)"
          fill="#601E82"
        />
        <circle
          cx="116.694"
          cy="120.845"
          r="1.91508"
          transform="rotate(90 116.694 120.845)"
          fill="#601E82"
        />
        <circle
          cx="138.033"
          cy="206.203"
          r="1.91508"
          transform="rotate(90 138.033 206.203)"
          fill="#601E82"
        />
        <circle
          cx="116.694"
          cy="206.203"
          r="1.91508"
          transform="rotate(90 116.694 206.203)"
          fill="#601E82"
        />
        <circle
          cx="138.033"
          cy="99.5057"
          r="1.91508"
          transform="rotate(90 138.033 99.5057)"
          fill="#601E82"
        />
        <circle
          cx="116.694"
          cy="99.5057"
          r="1.91508"
          transform="rotate(90 116.694 99.5057)"
          fill="#601E82"
        />
        <circle
          cx="138.033"
          cy="184.865"
          r="1.91508"
          transform="rotate(90 138.033 184.865)"
          fill="#601E82"
        />
        <circle
          cx="116.694"
          cy="184.865"
          r="1.91508"
          transform="rotate(90 116.694 184.865)"
          fill="#601E82"
        />
        <circle
          cx="138.033"
          cy="142.185"
          r="1.91508"
          transform="rotate(90 138.033 142.185)"
          fill="#601E82"
        />
        <circle
          cx="116.694"
          cy="142.185"
          r="1.91508"
          transform="rotate(90 116.694 142.185)"
          fill="#601E82"
        />
        <circle
          cx="138.033"
          cy="227.544"
          r="1.91508"
          transform="rotate(90 138.033 227.544)"
          fill="#601E82"
        />
        <circle
          cx="116.694"
          cy="227.544"
          r="1.91508"
          transform="rotate(90 116.694 227.544)"
          fill="#601E82"
        />
        <circle
          cx="95.3574"
          cy="78.1665"
          r="1.91508"
          transform="rotate(90 95.3574 78.1665)"
          fill="#601E82"
        />
        <circle
          cx="74.0185"
          cy="78.1665"
          r="1.91508"
          transform="rotate(90 74.0185 78.1665)"
          fill="#601E82"
        />
        <circle
          cx="95.3574"
          cy="163.525"
          r="1.91508"
          transform="rotate(90 95.3574 163.525)"
          fill="#601E82"
        />
        <circle
          cx="74.0185"
          cy="163.525"
          r="1.91508"
          transform="rotate(90 74.0185 163.525)"
          fill="#601E82"
        />
        <circle
          cx="95.3574"
          cy="120.845"
          r="1.91508"
          transform="rotate(90 95.3574 120.845)"
          fill="#601E82"
        />
        <circle
          cx="74.0185"
          cy="120.845"
          r="1.91508"
          transform="rotate(90 74.0185 120.845)"
          fill="#601E82"
        />
        <circle
          cx="95.3574"
          cy="206.203"
          r="1.91508"
          transform="rotate(90 95.3574 206.203)"
          fill="#601E82"
        />
        <circle
          cx="74.0185"
          cy="206.203"
          r="1.91508"
          transform="rotate(90 74.0185 206.203)"
          fill="#601E82"
        />
        <circle
          cx="95.3574"
          cy="99.5057"
          r="1.91508"
          transform="rotate(90 95.3574 99.5057)"
          fill="#601E82"
        />
        <circle
          cx="74.0185"
          cy="99.5057"
          r="1.91508"
          transform="rotate(90 74.0185 99.5057)"
          fill="#601E82"
        />
        <circle
          cx="95.3574"
          cy="184.865"
          r="1.91508"
          transform="rotate(90 95.3574 184.865)"
          fill="#601E82"
        />
        <circle
          cx="74.0185"
          cy="184.865"
          r="1.91508"
          transform="rotate(90 74.0185 184.865)"
          fill="#601E82"
        />
        <circle
          cx="95.3574"
          cy="142.185"
          r="1.91508"
          transform="rotate(90 95.3574 142.185)"
          fill="#601E82"
        />
        <circle
          cx="74.0185"
          cy="142.185"
          r="1.91508"
          transform="rotate(90 74.0185 142.185)"
          fill="#601E82"
        />
        <circle
          cx="95.3574"
          cy="227.542"
          r="1.91508"
          transform="rotate(90 95.3574 227.542)"
          fill="#601E82"
        />
        <circle
          cx="74.0185"
          cy="227.542"
          r="1.91508"
          transform="rotate(90 74.0185 227.542)"
          fill="#601E82"
        />
        <circle
          cx="52.6806"
          cy="78.1665"
          r="1.91508"
          transform="rotate(90 52.6806 78.1665)"
          fill="#601E82"
        />
        <circle
          cx="31.3418"
          cy="78.1665"
          r="1.91508"
          transform="rotate(90 31.3418 78.1665)"
          fill="#601E82"
        />
        <circle
          cx="52.6806"
          cy="163.525"
          r="1.91508"
          transform="rotate(90 52.6806 163.525)"
          fill="#601E82"
        />
        <circle
          cx="31.3418"
          cy="163.525"
          r="1.91508"
          transform="rotate(90 31.3418 163.525)"
          fill="#601E82"
        />
        <circle
          cx="52.6806"
          cy="120.845"
          r="1.91508"
          transform="rotate(90 52.6806 120.845)"
          fill="#601E82"
        />
        <circle
          cx="31.3418"
          cy="120.845"
          r="1.91508"
          transform="rotate(90 31.3418 120.845)"
          fill="#601E82"
        />
        <circle
          cx="52.6806"
          cy="206.203"
          r="1.91508"
          transform="rotate(90 52.6806 206.203)"
          fill="#601E82"
        />
        <circle
          cx="31.3418"
          cy="206.203"
          r="1.91508"
          transform="rotate(90 31.3418 206.203)"
          fill="#601E82"
        />
        <circle
          cx="52.6806"
          cy="99.5057"
          r="1.91508"
          transform="rotate(90 52.6806 99.5057)"
          fill="#601E82"
        />
        <circle
          cx="31.3418"
          cy="99.5057"
          r="1.91508"
          transform="rotate(90 31.3418 99.5057)"
          fill="#601E82"
        />
        <circle
          cx="52.6806"
          cy="184.865"
          r="1.91508"
          transform="rotate(90 52.6806 184.865)"
          fill="#601E82"
        />
        <circle
          cx="31.3418"
          cy="184.865"
          r="1.91508"
          transform="rotate(90 31.3418 184.865)"
          fill="#601E82"
        />
        <circle
          cx="52.6806"
          cy="142.185"
          r="1.91508"
          transform="rotate(90 52.6806 142.185)"
          fill="#601E82"
        />
        <circle
          cx="31.3418"
          cy="142.185"
          r="1.91508"
          transform="rotate(90 31.3418 142.185)"
          fill="#601E82"
        />
        <circle
          cx="52.6806"
          cy="227.544"
          r="1.91508"
          transform="rotate(90 52.6806 227.544)"
          fill="#601E82"
        />
        <circle
          cx="31.3418"
          cy="227.544"
          r="1.91508"
          transform="rotate(90 31.3418 227.544)"
          fill="#601E82"
        />
        <circle
          cx="9.99702"
          cy="78.1663"
          r="1.91508"
          transform="rotate(90 9.99702 78.1663)"
          fill="#601E82"
        />
        <circle
          cx="9.99702"
          cy="163.526"
          r="1.91508"
          transform="rotate(90 9.99702 163.526)"
          fill="#601E82"
        />
        <circle
          cx="9.99702"
          cy="120.845"
          r="1.91508"
          transform="rotate(90 9.99702 120.845)"
          fill="#601E82"
        />
        <circle
          cx="9.99702"
          cy="206.203"
          r="1.91508"
          transform="rotate(90 9.99702 206.203)"
          fill="#601E82"
        />
        <circle
          cx="9.99702"
          cy="99.5057"
          r="1.91508"
          transform="rotate(90 9.99702 99.5057)"
          fill="#601E82"
        />
        <circle
          cx="9.99702"
          cy="184.865"
          r="1.91508"
          transform="rotate(90 9.99702 184.865)"
          fill="#601E82"
        />
        <circle
          cx="9.99702"
          cy="142.185"
          r="1.91508"
          transform="rotate(90 9.99702 142.185)"
          fill="#601E82"
        />
        <circle
          cx="9.99702"
          cy="227.544"
          r="1.91508"
          transform="rotate(90 9.99702 227.544)"
          fill="#601E82"
        />
      </g>
      <path
        d="M53.5151 25.8627C52.8061 27.0043 51.3592 27.4856 50.1079 27.0095L46.4346 25.5895C44.79 24.984 44.0438 23.0144 44.8811 21.4795C48.7106 14.7417 55.6865 12.4688 62.5382 13.2875C72.1306 14.4332 78.7701 22.5031 77.8365 30.3215C76.4496 41.929 65.8688 42.2188 63.2161 50.7317C62.7297 52.0638 61.4763 52.9766 60.106 52.8131L56.0757 52.3318C54.3027 52.1196 53.1249 50.3446 53.6589 48.6089C56.6594 39.238 66.5074 37.553 67.3458 30.5399C67.8271 26.5096 65.6939 23.1479 60.6959 22.5507C57.15 22.1274 54.8326 23.7306 53.5151 25.8627ZM62.0652 66.5372C61.6802 69.7612 58.7025 72.1034 55.4774 71.7184C52.1727 71.3241 49.8305 68.3453 50.2155 65.1213C50.6098 61.8166 53.5875 59.4743 56.8933 59.8687C60.1173 60.2547 62.4595 63.2324 62.0652 66.5372Z"
        fill="#311F6E"
      />
      <path
        opacity="0.5"
        d="M177.812 347.329C222.366 347.329 258.485 341.501 258.485 334.311C258.485 327.122 222.366 321.294 177.812 321.294C133.257 321.294 97.1387 327.122 97.1387 334.311C97.1387 341.501 133.257 347.329 177.812 347.329Z"
        fill="#311F6E"
      />
      <path
        d="M254.66 245.986C254.469 246.847 254.21 247.678 253.892 248.476C251.94 253.386 247.706 257.112 242.454 258.342C227.816 261.786 196.836 265.962 160.468 252.658C160.468 252.658 152.681 180.902 167.769 144.926C167.769 144.926 201.43 137.942 246.735 151.996C250.605 153.192 253.776 155.751 255.792 159.055C257.225 161.4 258.079 164.126 258.178 167.004C258.836 186.048 259.437 224.618 254.66 245.986Z"
        fill="white"
      />
      <path
        d="M211.534 264.114C196.765 264.114 178.975 261.887 159.674 254.827C158.848 254.524 158.265 253.78 158.17 252.906C157.849 249.952 150.493 180.144 165.641 144.03C165.935 143.328 166.557 142.816 167.302 142.662C168.7 142.372 202.065 135.721 247.421 149.788C254.962 152.126 260.213 159.011 260.486 166.922C261.197 187.487 261.679 225.17 256.916 246.488C255.365 253.432 249.895 258.97 242.981 260.593C235.699 262.304 224.844 264.114 211.534 264.114ZM162.622 250.977C197.6 263.398 227.255 259.54 241.924 256.094C247.124 254.873 251.238 250.707 252.406 245.481C257.056 224.665 256.571 187.426 255.867 167.081C255.662 161.134 251.717 155.958 246.052 154.202C206.583 141.962 175.753 145.948 169.429 146.977C156.501 179.543 161.657 240.847 162.622 250.977Z"
        fill="#311F6E"
      />
      <path
        d="M254.182 159.93C254.187 159.923 254.124 159.9 254.078 159.881C254.032 159.86 253.975 159.84 253.919 159.821C253.81 159.779 253.695 159.74 253.574 159.704C253.339 159.624 253.086 159.563 252.839 159.494C252.334 159.373 251.817 159.266 251.292 159.191C250.24 159.038 249.158 158.972 248.074 159.028C246.991 159.081 245.893 159.209 244.82 159.48C243.733 159.716 242.685 160.113 241.636 160.547L241.587 160.567C241.157 160.745 240.664 160.541 240.486 160.111C240.331 159.736 240.467 159.315 240.787 159.094C241.802 158.397 242.86 157.722 244.008 157.204C245.143 156.652 246.349 156.24 247.588 155.915C248.828 155.587 250.11 155.392 251.411 155.307C252.062 155.264 252.719 155.257 253.383 155.275C253.718 155.294 254.05 155.306 254.392 155.342C254.561 155.356 254.735 155.376 254.912 155.401L255.183 155.441C255.279 155.457 255.36 155.468 255.505 155.503C256.727 155.868 257.423 157.155 257.058 158.378C256.692 159.601 255.406 160.295 254.182 159.93Z"
        fill="#311F6E"
      />
      <g opacity="0.2">
        <g opacity="0.2">
          <path
            opacity="0.2"
            d="M248.494 250.855C250.036 250.092 251.383 249.047 252.618 247.857C250.666 252.767 246.432 256.493 241.181 257.723C226.543 261.167 195.563 265.343 159.194 252.039C159.194 252.039 151.408 180.283 166.496 144.307C166.496 144.307 200.156 137.323 245.461 151.377C249.331 152.573 252.502 155.132 254.519 158.436C252.485 158.615 250.47 159.401 249.013 160.781C245.034 164.548 244.167 170.469 243.537 175.91C242.192 187.446 240.845 198.981 239.5 210.511C238.385 220.054 237.276 229.596 236.161 239.134C235.745 242.715 235.456 246.753 237.796 249.497C240.308 252.444 245.023 252.576 248.494 250.855Z"
            fill="#311F6E"
          />
        </g>
      </g>
      <path
        d="M296.124 186.186C294.455 190.085 282.757 186.186 282.757 186.186C282.757 186.186 285.541 193.985 290.556 198.999C291.63 200.073 292.606 201.379 293.335 202.823C296.021 208.109 295.49 215.231 284.987 219.61C271.615 225.178 262.702 214.595 257.693 207.352C257.693 207.352 252.119 224.399 234.853 221.169C234.853 221.169 238.752 236.316 234.298 247.458C229.839 258.601 230.399 293.134 230.399 293.134C230.399 293.134 233.738 322.097 230.399 329.341C227.054 336.585 192.887 341.594 177.665 333.24C177.665 333.24 148.516 338.809 130.691 334.91C119.651 332.495 118.653 324.951 121.748 319.163C123.643 315.605 127.086 312.711 130.691 312.076C130.691 312.076 123.516 243.006 125.711 211.812C125.711 211.812 108.41 216.266 98.3821 210.137C88.354 204.014 78.8858 182.843 78.8858 182.843C78.8858 182.843 69.4176 190.087 61.62 182.289C53.8212 174.49 77.2164 167.807 77.2164 167.807C77.2164 167.807 72.2028 164.526 74.4322 159.824C76.6564 155.116 79.631 159.576 86.8056 158.091C93.9854 156.601 103.892 158.582 115.775 170.962C115.775 170.962 119.992 162.361 132.307 155.053C141.897 149.346 156.407 144.424 177.665 144.967C201.367 145.573 223.802 150.904 236.736 160.731C242.559 165.155 246.458 170.493 247.665 176.72C247.665 176.72 263.262 172.117 276.074 173.023C288.886 173.929 297.794 182.288 296.124 186.186Z"
        fill="white"
      />
      <g opacity="0.2">
        <g opacity="0.2">
          <path
            opacity="0.2"
            d="M293.333 202.823C287.367 207.294 279.118 208.669 272.07 206.179C265.145 203.737 259.663 197.661 257.731 190.6C257.325 189.117 255.594 188.482 254.325 189.349C252.134 190.848 249.862 192.215 247.375 193.113C243.817 194.401 239.704 194.626 236.799 191.824C240.01 187.128 243.217 182.425 246.723 177.36C246.868 177.077 247.012 176.788 246.544 176.124C243.957 180.26 238.463 182.328 233.79 180.918C231.417 180.205 229.362 178.629 227.917 176.591C225.792 173.596 226.507 169.405 229.473 167.24C232.115 165.31 234.557 163.121 236.736 160.73C223.802 150.904 201.365 145.572 177.665 144.965C156.407 144.422 141.896 149.343 132.307 155.052C163.738 177.978 187.538 178.758 199.619 177.823C204.85 177.418 209.227 181.859 208.639 187.073C208.245 190.574 206.952 193.945 204.623 196.683C200.059 202.061 193.33 205.1 186.612 207.249C167.936 213.21 147.955 213.504 128.361 212.794C127.852 219.073 127.344 225.358 126.836 231.649C150.642 239.162 176.05 241.521 201.598 239.513C204.991 239.246 206.422 243.758 203.475 245.459C194.105 250.865 183.32 253.833 172.499 253.837C157.567 253.837 142.704 248.199 131.527 238.292C131.723 252.577 142.756 265.985 156.816 269.046C155.498 278.901 155.643 288.953 157.33 298.744C157.931 306.865 158.532 314.982 158.48 322.15C147.412 329.388 131.527 327.991 121.747 319.163C118.651 324.951 119.65 332.495 130.689 334.91C148.516 338.808 177.664 333.24 177.664 333.24C192.886 341.593 227.053 336.585 230.398 329.341C233.737 322.097 230.398 293.134 230.398 293.134C230.398 293.134 229.838 258.602 234.297 247.458C238.751 236.316 234.852 221.169 234.852 221.169C252.118 224.399 257.692 207.352 257.692 207.352C262.701 214.596 271.614 225.178 284.986 219.61C295.488 215.232 296.019 208.109 293.333 202.823ZM207.65 320.988C205.148 325.979 199.569 328.919 194.012 329.41C188.449 329.9 182.903 328.266 177.814 325.845C178.062 318.03 183.232 312.576 181.927 312.126C187.079 295.322 183.406 276.075 174.296 262.482C182.61 261.574 190.826 259.802 198.775 257.21C202.2 256.094 205.755 258.528 206.005 262.121C207.053 277.156 208.096 292.194 209.14 307.228C209.464 311.89 209.742 316.812 207.65 320.988Z"
            fill="#311F6E"
          />
        </g>
      </g>
      <path
        d="M199.659 339.889C191.51 339.889 183.311 338.699 177.296 335.657C172.361 336.545 146.825 340.804 130.196 337.166C119.206 334.763 117.914 327.887 117.914 324.799C117.914 324.721 117.915 324.647 117.916 324.574C118.039 318.58 122.634 312.45 128.194 310.374C127.201 300.475 122.979 256.553 122.978 226.129C122.978 222.035 123.053 218.186 123.225 214.698C117.569 215.723 105.369 217.114 97.1772 212.108C88.6291 206.888 80.7652 192.036 77.9044 186.177C73.3897 188.523 66.0443 189.98 59.9865 183.922C58.2291 182.164 57.7167 180.444 57.7178 179.036C57.7178 178.482 57.7975 177.977 57.9124 177.535C59.2558 172.35 67.7697 168.591 72.9851 166.742C72.155 165.482 71.5464 163.948 71.5464 162.23C71.5464 161.161 71.7824 160.022 72.3454 158.832C74.3833 154.517 77.6695 155.167 80.0676 155.645C81.7784 155.984 83.718 156.368 86.3376 155.827C92.8591 154.475 103.057 155.464 115.343 167.259C117.252 164.505 120.958 160.017 127.187 155.612C136.055 149.34 152.021 142.001 177.723 142.655C195.637 143.113 212.421 146.26 224.985 151.518C238.18 157.041 246.539 164.733 249.333 173.872C254.237 172.613 265.98 169.992 276.236 170.717C286.33 171.431 294.532 176.594 297.419 181.325C298.333 182.824 298.639 184.105 298.639 185.149C298.639 185.936 298.466 186.588 298.248 187.096C296.656 190.815 291.314 190.616 286.852 189.693C288.092 192.102 289.9 195.077 292.189 197.365C294.664 199.841 297.015 203.825 297.014 208.21C297.014 208.975 296.943 209.751 296.787 210.535C296.133 213.845 293.709 218.475 285.875 221.743C272.358 227.371 262.944 218.103 258.169 211.951C254.963 217.736 248.323 224.413 237.769 223.848C238.228 226.432 238.748 230.307 238.748 234.606C238.748 239.047 238.193 243.937 236.442 248.317C233.025 256.854 232.687 280.52 232.687 289.544C232.687 289.546 232.687 289.549 232.687 289.552C232.687 289.555 232.687 289.557 232.687 289.56C232.687 291.395 232.701 292.622 232.705 292.987C232.961 295.223 234.193 306.515 234.193 316.431C234.193 322.218 233.773 327.536 232.495 330.31C231.359 332.772 228.168 334.882 223.01 336.58C217.145 338.51 208.431 339.889 199.659 339.889ZM177.664 330.93C178.05 330.93 178.433 331.027 178.776 331.215C188.889 336.764 209.444 336.182 221.567 332.189C225.895 330.763 227.899 329.242 228.3 328.372C229.23 326.355 229.582 321.979 229.582 316.735C229.582 309.284 228.873 300.079 228.103 293.398C228.094 293.322 228.089 293.247 228.088 293.17C228.084 292.897 228.062 291.448 228.062 289.202C228.062 279.684 228.447 255.857 232.153 246.598C233.645 242.864 234.123 238.598 234.123 234.666C234.123 227.73 232.638 221.837 232.615 221.745C232.567 221.554 232.542 221.362 232.542 221.171C232.541 220.591 232.759 220.025 233.165 219.591C233.704 219.014 234.502 218.753 235.277 218.899C250.296 221.707 255.293 207.246 255.498 206.629C255.774 205.798 256.498 205.191 257.365 205.068C258.231 204.944 259.096 205.317 259.594 206.039C265.003 213.862 272.676 222.233 284.099 217.478C288.809 215.514 291.63 212.802 292.255 209.639C292.351 209.152 292.396 208.666 292.396 208.183C292.396 205.211 290.697 202.41 288.921 200.634C283.601 195.314 280.701 187.303 280.58 186.965C280.49 186.711 280.446 186.448 280.446 186.188C280.446 185.594 280.675 185.012 281.105 184.572C281.724 183.94 282.649 183.717 283.486 183.996C288.335 185.608 293.167 185.996 294.006 185.254C294.011 185.232 294.014 185.201 294.014 185.16C294.014 184.946 293.925 184.472 293.474 183.733C291.26 180.105 284.353 175.926 275.911 175.328C263.66 174.461 248.471 178.891 248.319 178.936C247.695 179.12 247.021 179.032 246.466 178.695C245.909 178.357 245.521 177.8 245.397 177.161C241.598 157.616 208.611 148.068 177.607 147.277C153.357 146.649 138.394 153.423 130.113 159.207C121.179 165.447 117.879 171.921 117.847 171.986C117.512 172.658 116.868 173.129 116.126 173.242C115.383 173.353 114.63 173.103 114.11 172.561C104.667 162.724 95.6381 158.618 87.2763 160.353C83.7387 161.086 81.0974 160.561 79.1692 160.179C77.0216 159.752 77.0226 159.752 76.5227 160.81C76.2878 161.306 76.1905 161.78 76.1894 162.224C76.1884 164.257 78.216 165.693 78.4954 165.881C79.1402 166.315 79.5211 167.042 79.5211 167.805C79.5211 167.924 79.5118 168.043 79.4931 168.163C79.3534 169.05 78.7169 169.78 77.8537 170.028C72.0939 171.678 63.194 175.572 62.3856 178.695C62.367 178.766 62.3401 178.873 62.3401 179.017C62.3401 179.352 62.4912 179.889 63.2561 180.654C69.5013 186.899 77.1675 181.246 77.4904 181.002C78.0524 180.579 78.78 180.431 79.4611 180.608C80.1421 180.783 80.7103 181.257 80.997 181.899C81.0891 182.104 90.2913 202.489 99.5877 208.165C108.653 213.705 124.974 209.616 125.138 209.574C125.856 209.39 126.622 209.562 127.191 210.038C127.719 210.478 128.022 211.129 128.022 211.81C128.022 211.865 128.02 211.919 128.017 211.974C127.731 216.029 127.607 220.746 127.607 225.882C127.606 259.56 132.927 311.239 132.989 311.836C132.997 311.916 133.002 311.996 133.002 312.074C133.003 313.184 132.207 314.154 131.092 314.35C126.787 315.109 122.631 320.125 122.538 324.669C122.537 324.723 122.537 324.777 122.537 324.83C122.538 329.726 127.227 331.787 131.185 332.652C148.337 336.405 176.946 331.025 177.232 330.97C177.374 330.944 177.52 330.93 177.664 330.93ZM180.144 319.833C180.05 319.833 179.954 319.828 179.859 319.815C178.811 319.686 177.984 318.862 177.85 317.814C177.831 317.661 175.872 302.5 172.367 295.255C172.102 294.707 172.064 294.077 172.26 293.502C172.298 293.39 176.094 282.186 175.869 275.764C175.831 274.672 176.563 273.703 177.623 273.44C178.681 273.177 179.782 273.693 180.258 274.676C180.689 275.567 190.732 296.749 182.295 318.363C181.946 319.257 181.085 319.833 180.144 319.833ZM176.926 294.108C178.465 297.608 179.685 302.265 180.582 306.483C181.613 298.623 180.544 291.285 179.193 285.858C178.382 289.437 177.407 292.614 176.926 294.108Z"
        fill="#311F6E"
      />
      <path
        d="M234.461 223.445L234.177 223.383L233.975 223.326L233.582 223.211L232.873 222.956C232.409 222.779 231.984 222.573 231.543 222.377L230.301 221.714C229.903 221.476 229.519 221.223 229.128 220.978C228.73 220.741 228.375 220.459 228.009 220.188C227.648 219.913 227.272 219.652 226.927 219.362L225.912 218.475C225.574 218.179 225.23 217.889 224.927 217.563L223.993 216.611C223.681 216.295 223.365 215.981 223.091 215.636C222.527 214.959 221.946 214.296 221.4 213.609L219.863 211.485C219.597 211.137 219.373 210.766 219.145 210.396L218.459 209.291C217.498 207.841 216.765 206.28 215.94 204.768C215.534 204.009 215.22 203.21 214.857 202.434C214.51 201.65 214.144 200.875 213.815 200.087C213.217 198.488 212.586 196.903 212.021 195.299L210.489 190.439C210.256 189.701 210.666 188.914 211.404 188.682C212.121 188.456 212.884 188.836 213.14 189.534L213.167 189.608L214.865 194.252C215.481 195.777 216.158 197.272 216.798 198.781C217.148 199.521 217.531 200.243 217.896 200.973C218.275 201.696 218.607 202.445 219.024 203.143C219.867 204.53 220.623 205.977 221.577 207.277L222.26 208.274C222.487 208.608 222.709 208.943 222.968 209.248L224.461 211.126C224.983 211.725 225.534 212.295 226.066 212.881C226.326 213.182 226.619 213.443 226.906 213.71L227.766 214.512C228.045 214.791 228.354 215.024 228.658 215.266L229.565 215.991C229.871 216.226 230.197 216.425 230.509 216.644C230.826 216.858 231.135 217.085 231.468 217.258C231.795 217.442 232.119 217.637 232.446 217.814L233.44 218.289C233.771 218.413 234.107 218.56 234.43 218.666L234.908 218.815L235.119 218.864L235.22 218.889C235.229 218.889 235.237 218.89 235.244 218.892L235.601 218.997C236.82 219.353 237.519 220.629 237.163 221.847C236.822 223.012 235.629 223.7 234.461 223.445Z"
        fill="#311F6E"
      />
      <path
        d="M123.418 211.503C124.051 207.656 124.81 203.937 125.653 200.19C126.498 196.456 127.443 192.744 128.482 189.058C129.512 185.371 130.698 181.722 131.971 178.105C133.261 174.492 134.73 170.938 136.341 167.446C136.649 166.778 137.44 166.486 138.109 166.795C138.759 167.095 139.052 167.851 138.785 168.506L138.772 168.535C137.352 171.999 136.07 175.52 134.961 179.106C133.868 182.696 132.861 186.316 132.006 189.978C131.143 193.636 130.373 197.318 129.701 201.016C129.035 204.705 128.44 208.452 127.997 212.116L127.992 212.157C127.839 213.424 126.688 214.327 125.42 214.175C124.152 214.022 123.249 212.871 123.401 211.603C123.408 211.572 123.414 211.532 123.418 211.503Z"
        fill="#311F6E"
      />
      <path
        d="M124.528 204.721C125.546 200.948 126.661 197.212 127.874 193.515C128.104 192.813 128.86 192.432 129.561 192.661C130.19 192.867 130.561 193.498 130.467 194.131C129.901 197.93 129.436 201.739 129.076 205.546C128.955 206.821 127.824 207.757 126.548 207.636C125.273 207.515 124.338 206.383 124.459 205.108C124.471 204.98 124.493 204.856 124.525 204.736L124.528 204.721Z"
        fill="#39005E"
      />
      <path
        d="M96.073 210.229C95.9291 206.341 96.015 202.42 96.4942 198.511C96.9838 194.607 97.8066 190.703 99.1966 186.943C100.571 183.186 102.512 179.571 105.101 176.401C106.4 174.823 107.85 173.35 109.474 172.061C110.279 171.409 111.139 170.816 112.036 170.263C112.483 169.985 112.949 169.729 113.427 169.481C113.67 169.359 113.91 169.239 114.168 169.125L114.56 168.955L114.77 168.87L115.034 168.772L115.27 168.691C116.42 168.291 117.676 168.901 118.075 170.051C118.297 170.69 118.202 171.371 117.88 171.911C117.777 172.081 117.633 172.376 117.512 172.622L117.14 173.414C116.895 173.949 116.663 174.5 116.437 175.055C115.984 176.165 115.568 177.301 115.174 178.45C114.783 179.6 114.419 180.764 114.08 181.938C113.738 183.112 113.429 184.298 113.132 185.491L113.129 185.503C112.983 186.086 112.393 186.44 111.81 186.295C111.286 186.165 110.947 185.674 110.989 185.153C111.09 183.901 111.204 182.647 111.353 181.392C111.501 180.138 111.674 178.883 111.881 177.629C112.091 176.374 112.327 175.121 112.609 173.866C112.753 173.237 112.902 172.61 113.073 171.979L113.339 171.028C113.44 170.695 113.521 170.412 113.667 170.016L116.513 173.154L116.325 173.229L116.066 173.342C115.89 173.42 115.707 173.512 115.527 173.602C115.165 173.79 114.799 173.99 114.441 174.213C113.725 174.655 113.02 175.139 112.354 175.68C111.008 176.747 109.784 177.99 108.676 179.336C106.468 182.039 104.761 185.189 103.534 188.544C102.292 191.897 101.536 195.459 101.083 199.069C100.639 202.685 100.557 206.368 100.692 210.051V210.064C100.739 211.339 99.7431 212.411 98.468 212.458C97.1918 212.5 96.1196 211.504 96.073 210.229Z"
        fill="#311F6E"
      />
      <path
        d="M241.213 223.768C240.497 223.769 239.79 223.436 239.339 222.812C229.427 209.102 231.855 196.754 235.637 188.808C239.663 180.349 245.934 175.147 246.198 174.93C247.185 174.121 248.641 174.264 249.45 175.251C250.259 176.237 250.116 177.691 249.132 178.501C249.051 178.568 243.301 183.375 239.745 190.931C235.101 200.802 236.224 210.617 243.083 220.103C243.83 221.138 243.599 222.582 242.565 223.329C242.155 223.627 241.682 223.768 241.213 223.768Z"
        fill="#311F6E"
      />
      <path
        d="M255.674 208.482C255.435 207.89 255.276 207.397 255.098 206.861C254.928 206.335 254.766 205.81 254.617 205.285C254.317 204.235 254.047 203.184 253.808 202.131C253.332 200.023 252.969 197.908 252.713 195.793C252.677 195.495 252.89 195.224 253.188 195.188C253.434 195.158 253.662 195.298 253.754 195.515L253.755 195.519C254.572 197.446 255.481 199.319 256.474 201.126C256.972 202.028 257.494 202.914 258.035 203.777C258.304 204.21 258.582 204.634 258.864 205.051C259.14 205.456 259.446 205.9 259.706 206.225C260.517 207.233 260.356 208.707 259.348 209.518C258.34 210.329 256.866 210.168 256.055 209.16C255.91 208.98 255.796 208.785 255.712 208.581L255.674 208.482Z"
        fill="#311F6E"
      />
      <path
        d="M285.064 186.068C285.064 186.279 285.053 186.37 285.044 186.507L285.008 186.872C284.98 187.111 284.947 187.341 284.905 187.57C284.825 188.028 284.724 188.476 284.597 188.918C284.349 189.801 284.012 190.66 283.576 191.474C282.714 193.104 281.429 194.548 279.889 195.517C279.121 196.001 278.306 196.375 277.48 196.661C276.648 196.917 275.813 197.122 274.978 197.212C273.31 197.427 271.674 197.347 270.09 197.128C269.689 197.074 269.408 196.703 269.464 196.301C269.514 195.942 269.816 195.679 270.167 195.668H270.172C271.675 195.62 273.158 195.428 274.522 195.006C275.209 194.811 275.848 194.523 276.456 194.219C277.049 193.888 277.594 193.509 278.072 193.076C279.028 192.207 279.686 191.115 280.075 189.92C280.271 189.322 280.397 188.696 280.459 188.064C280.493 187.748 280.507 187.43 280.505 187.119C280.507 186.964 280.5 186.808 280.491 186.66L280.473 186.445C280.466 186.389 280.457 186.288 280.45 186.304C280.384 185.03 281.366 183.945 282.64 183.879C283.913 183.813 284.998 184.794 285.064 186.068Z"
        fill="#311F6E"
      />
      <path
        d="M175.48 333.994C174.253 330.955 173.618 327.456 174.208 323.925C174.506 322.172 175.11 320.438 176.039 318.873C176.511 318.093 177.051 317.356 177.693 316.664C178.033 316.313 178.325 315.996 178.867 315.598C179.26 315.322 179.618 315.106 179.991 314.889C182.928 313.212 186.134 312.257 189.39 311.989C192.639 311.712 195.9 312.176 198.85 313.268C199.305 313.436 199.538 313.943 199.369 314.398C199.226 314.783 198.843 315.009 198.453 314.967L198.442 314.966C195.517 314.66 192.633 314.766 189.905 315.409C188.543 315.729 187.219 316.167 185.955 316.714C184.7 317.279 183.477 317.924 182.397 318.693C182.133 318.882 181.862 319.086 181.654 319.266C181.593 319.323 181.365 319.561 181.199 319.769C180.842 320.211 180.515 320.72 180.239 321.252C179.684 322.321 179.312 323.495 179.129 324.722C178.752 327.184 179.121 329.832 179.848 332.488L179.856 332.517C180.194 333.749 179.468 335.021 178.235 335.359C177.092 335.671 175.913 335.068 175.48 333.994Z"
        fill="#311F6E"
      />
      <path
        d="M130.118 309.836C130.279 309.804 130.388 309.79 130.504 309.773C130.623 309.754 130.734 309.74 130.844 309.729C131.067 309.703 131.288 309.677 131.504 309.663C131.94 309.622 132.371 309.605 132.799 309.586C133.656 309.559 134.507 309.574 135.354 309.619C137.045 309.713 138.718 309.967 140.349 310.367C141.169 310.542 141.966 310.82 142.761 311.064C143.541 311.373 144.33 311.633 145.075 312.013C146.598 312.681 147.994 313.593 149.329 314.534C149.702 314.796 149.792 315.311 149.529 315.684C149.292 316.021 148.85 316.126 148.492 315.952L148.441 315.927C147.07 315.257 145.691 314.634 144.233 314.255C143.522 314.021 142.776 313.903 142.052 313.738C141.31 313.636 140.582 313.5 139.837 313.462C138.359 313.338 136.875 313.348 135.413 313.5C134.682 313.576 133.957 313.678 133.246 313.814C132.892 313.887 132.538 313.957 132.197 314.045C132.022 314.084 131.857 314.132 131.692 314.179C131.607 314.201 131.526 314.224 131.453 314.249C131.376 314.273 131.291 314.299 131.26 314.314C130.101 314.896 128.688 314.428 128.106 313.269C127.525 312.109 127.993 310.697 129.152 310.115C129.341 310.02 129.538 309.953 129.737 309.912L130.118 309.836Z"
        fill="#311F6E"
      />
      <path
        d="M205.179 300.937C193.029 300.937 183.506 299 182.853 298.865C181.604 298.605 180.803 297.382 181.063 296.132C181.322 294.883 182.548 294.083 183.795 294.341C184.051 294.394 209.573 299.566 229.865 292.799C231.076 292.396 232.384 293.049 232.788 294.26C233.191 295.47 232.537 296.779 231.326 297.183C222.689 300.062 213.342 300.937 205.179 300.937Z"
        fill="#311F6E"
      />
      <path
        d="M151.875 301.612C139.516 301.612 129.158 298.378 128.464 298.157C127.248 297.769 126.577 296.469 126.966 295.253C127.353 294.038 128.653 293.367 129.868 293.754C130.125 293.836 155.813 301.828 173.335 292.222C174.453 291.608 175.858 292.018 176.472 293.137C177.085 294.256 176.676 295.66 175.557 296.274C168.136 300.343 159.613 301.612 151.875 301.612Z"
        fill="#311F6E"
      />
      <path
        d="M178.178 277.994C177.236 277.994 176.351 277.414 176.009 276.479L171.039 262.923C170.599 261.725 171.215 260.398 172.412 259.958C173.61 259.519 174.937 260.134 175.377 261.333L180.347 274.888C180.787 276.086 180.171 277.413 178.974 277.853C178.711 277.948 178.442 277.994 178.178 277.994Z"
        fill="#311F6E"
      />
      <path
        d="M137.512 248.966C138.518 249.632 139.653 250.287 140.759 250.898C141.883 251.5 143.01 252.093 144.165 252.635C146.462 253.738 148.828 254.684 151.218 255.54C151.815 255.754 152.416 255.961 153.022 256.146C153.625 256.341 154.23 256.532 154.842 256.7C156.054 257.071 157.281 257.386 158.511 257.683C160.975 258.265 163.467 258.713 165.975 259.023C167.227 259.2 168.49 259.268 169.748 259.396C171.009 259.457 172.271 259.563 173.536 259.552C174.168 259.555 174.801 259.574 175.433 259.565L177.331 259.53C177.965 259.532 178.596 259.467 179.228 259.435C179.861 259.389 180.495 259.371 181.126 259.307C186.188 258.881 191.218 257.962 196.243 256.745L196.25 256.743C196.85 256.598 197.455 256.967 197.599 257.567C197.729 258.102 197.45 258.639 196.963 258.854C192.092 260.999 186.879 262.422 181.557 263.188C178.891 263.521 176.2 263.775 173.503 263.744C172.154 263.771 170.806 263.679 169.459 263.629C168.113 263.528 166.769 263.409 165.434 263.213C162.762 262.848 160.102 262.36 157.508 261.626C156.21 261.265 154.917 260.885 153.645 260.448C153.005 260.239 152.377 259.995 151.75 259.755C151.119 259.522 150.497 259.268 149.878 259.006C147.395 257.977 144.994 256.759 142.684 255.395C141.537 254.699 140.402 253.984 139.31 253.201C138.206 252.417 137.171 251.613 136.12 250.666C135.67 250.26 135.634 249.566 136.041 249.115C136.409 248.707 137.016 248.639 137.462 248.934L137.512 248.966Z"
        fill="#311F6E"
      />
      <path
        d="M230.763 219.419C227.961 219.645 225.269 219.737 222.728 219.737C209.257 219.737 199.829 217.074 199.315 216.924C196.247 216.034 194.481 212.834 195.37 209.767C196.254 206.705 199.454 204.944 202.515 205.821C202.694 205.873 209.672 207.802 219.886 208.132C223.899 214.422 227.908 217.716 230.763 219.419Z"
        fill="white"
      />
      <path
        d="M222.727 222.047C208.781 222.047 199.073 219.261 198.667 219.142C196.595 218.541 194.878 217.168 193.834 215.278C192.79 213.385 192.548 211.2 193.15 209.123C194.383 204.852 198.87 202.373 203.153 203.6C203.22 203.62 209.96 205.5 219.96 205.822C220.722 205.847 221.423 206.246 221.833 206.889C225.675 212.907 229.454 215.946 231.947 217.435C232.811 217.951 233.241 218.965 233.013 219.943C232.786 220.922 231.95 221.641 230.949 221.721C228.262 221.938 225.496 222.047 222.727 222.047ZM200.919 207.906C199.416 207.906 198.026 208.893 197.589 210.408C197.331 211.3 197.434 212.236 197.881 213.046C198.328 213.856 199.066 214.446 199.959 214.705C200.056 214.733 209.436 217.426 222.728 217.426C223.294 217.426 223.86 217.421 224.425 217.411C222.588 215.651 220.599 213.361 218.605 210.394C208.674 209.945 201.939 208.06 201.871 208.04C201.554 207.949 201.234 207.906 200.919 207.906Z"
        fill="#311F6E"
      />
      <path
        d="M131.133 192.605C131.327 193.24 131.403 194.1 131.254 194.826L131.197 195.092L131.162 195.216L131.112 195.387L131.011 195.731C130.875 196.189 130.756 196.65 130.63 197.111L129.905 199.881C129.665 200.806 129.446 201.735 129.235 202.667C129.025 203.598 128.811 204.53 128.623 205.465L128.6 205.578C128.406 206.54 127.47 207.162 126.508 206.968C126.472 206.961 126.431 206.951 126.396 206.941L124.997 206.563L124.298 206.374L123.95 206.279C123.826 206.242 123.667 206.181 123.528 206.132C122.386 205.715 121.346 205.035 120.534 204.14C118.878 202.381 118.192 199.798 118.707 197.458C118.959 196.298 119.483 195.184 120.247 194.26C121.015 193.341 122 192.621 123.087 192.134C124.179 191.657 125.377 191.394 126.605 191.388C126.905 191.411 127.228 191.4 127.521 191.438C127.833 191.481 128.047 191.488 128.541 191.593C129.418 191.777 130.351 192.169 131.133 192.605ZM127.207 195.042C127.09 195.257 127.123 195.427 127.101 195.388C127.146 195.38 126.909 195.285 126.769 195.223C126.611 195.152 126.468 195.117 126.311 195.07C125.691 194.927 125.013 194.978 124.397 195.213C123.781 195.457 123.248 195.882 122.828 196.383C122.416 196.893 122.137 197.505 122 198.153C121.715 199.439 122.158 200.835 123.071 201.753C123.515 202.223 124.087 202.563 124.695 202.747C124.775 202.77 124.832 202.796 124.932 202.82L125.257 202.892L125.907 203.037L127.205 203.327L124.978 204.804L125.437 201.924L125.914 199.046L126.411 196.169L126.668 194.731L126.731 194.371L126.762 194.191L126.77 194.145C126.774 194.126 126.775 194.113 126.769 194.138C126.762 194.166 126.756 194.196 126.753 194.228C126.717 194.485 126.903 194.876 127.207 195.042Z"
        fill="#311F6E"
      />
      <path
        d="M75.3441 166.451C75.4321 166.343 75.49 166.284 75.548 166.225C75.608 166.162 75.667 166.101 75.7229 166.049C75.8367 165.942 75.9506 165.828 76.0655 165.733C76.2921 165.529 76.526 165.341 76.761 165.161C77.2309 164.799 77.7277 164.483 78.2328 164.189C79.2522 163.614 80.3597 163.189 81.4982 162.949C82.6325 162.707 83.8 162.639 84.9147 162.795C85.4767 162.837 86.0129 162.989 86.5448 163.118C87.0737 163.256 87.5705 163.48 88.0715 163.658C88.5403 163.825 88.7856 164.341 88.619 164.809C88.4782 165.206 88.0891 165.442 87.6885 165.405L87.5271 165.389C87.0706 165.348 86.6266 165.258 86.1826 165.252C85.7386 165.256 85.3029 165.234 84.8775 165.31C84.0246 165.393 83.2194 165.653 82.4856 166.011C81.7497 166.367 81.078 166.836 80.4891 167.394C80.1993 167.679 79.9208 167.97 79.6745 168.284C79.5503 168.44 79.4313 168.596 79.3257 168.755C79.2667 168.833 79.2253 168.911 79.1756 168.988C79.1498 169.027 79.1311 169.062 79.1146 169.095C79.0939 169.132 79.0753 169.168 79.0897 169.159C78.3414 170.193 76.8966 170.425 75.8636 169.677C74.8276 168.93 74.5958 167.485 75.3441 166.451Z"
        fill="#311F6E"
      />
      <g opacity="0.2">
        <g opacity="0.2">
          <path
            opacity="0.2"
            d="M132.314 180.526C128.053 185.293 122.655 189.036 116.696 191.355C113.647 192.541 110.264 193.36 107.12 192.448C103.978 191.537 101.301 188.388 101.692 185.088C97.2442 184.018 93.2678 181.243 90.5892 177.545C88.5658 174.752 84.9039 173.727 81.711 175.033C74.969 177.789 67.5429 178.881 60.2979 178.113C61.5543 181.527 64.4565 184.292 67.9268 185.383C71.3972 186.474 75.3592 185.868 78.3431 183.787C81.1717 193.458 87.8671 201.938 96.617 206.934C105.367 211.93 116.073 213.385 125.791 210.434C128.408 200.482 130.524 190.398 132.314 180.526Z"
            fill="#311F6E"
          />
        </g>
      </g>
      <path
        d="M191.707 232.901L133.206 224.864C129.179 224.311 126.362 220.598 126.916 216.571L131.604 182.452C132.157 178.425 135.87 175.609 139.897 176.163L198.398 184.199C202.426 184.753 205.242 188.466 204.688 192.493L200.001 226.611C199.447 230.639 195.734 233.455 191.707 232.901Z"
        fill="white"
      />
      <path
        d="M192.715 235.281C192.279 235.281 191.837 235.251 191.393 235.191L132.891 227.154C127.609 226.427 123.901 221.539 124.627 216.256L129.314 182.138C130.04 176.855 134.927 173.151 140.212 173.872L198.713 181.909C203.996 182.635 207.704 187.524 206.978 192.806L202.29 226.926C201.625 231.765 197.468 235.281 192.715 235.281ZM138.891 178.403C136.409 178.403 134.239 180.239 133.891 182.766L129.204 216.885C128.825 219.643 130.76 222.195 133.52 222.575L192.021 230.612C194.778 230.996 197.331 229.055 197.711 226.297L202.399 192.177C202.778 189.418 200.842 186.866 198.083 186.487L139.582 178.45C139.35 178.419 139.119 178.403 138.891 178.403Z"
        fill="#311F6E"
      />
      <path
        d="M182.06 233.816C181.617 233.816 181.171 233.786 180.724 233.725L132.891 227.154C127.609 226.427 123.901 221.539 124.627 216.256L129.314 182.138C130.04 176.855 134.927 173.151 140.212 173.872L188.044 180.443C193.327 181.17 197.035 186.058 196.309 191.341L191.621 225.46C191.269 228.019 189.943 230.288 187.884 231.849C186.184 233.138 184.156 233.816 182.06 233.816ZM138.891 178.403C136.409 178.403 134.239 180.239 133.891 182.766L129.204 216.885C128.825 219.643 130.76 222.195 133.52 222.575L181.352 229.146C182.689 229.334 184.016 228.983 185.09 228.167C186.166 227.352 186.858 226.166 187.041 224.83L191.729 190.711C192.108 187.953 190.171 185.401 187.413 185.021L139.581 178.45C139.35 178.419 139.119 178.403 138.891 178.403Z"
        fill="#311F6E"
      />
      <path
        d="M181.292 206.765C184.386 203.671 184.386 198.656 181.292 195.562C178.198 192.468 173.183 192.468 170.089 195.562C166.995 198.656 166.995 203.671 170.089 206.765C173.183 209.859 178.198 209.859 181.292 206.765Z"
        fill="#4599F4"
      />
      <g opacity="0.7">
        <g opacity="0.7">
          <path
            opacity="0.7"
            d="M176.448 197.674C179.57 197.674 182.263 199.485 183.553 202.11C183.59 201.799 183.615 201.485 183.615 201.164C183.615 196.789 180.068 193.242 175.693 193.242C171.318 193.242 167.771 196.789 167.771 201.164C167.771 202.416 168.071 203.597 168.588 204.65C169.056 200.721 172.394 197.674 176.448 197.674Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M175.694 211.396C170.051 211.396 165.461 206.806 165.461 201.164C165.461 195.521 170.051 190.931 175.694 190.931C181.336 190.931 185.926 195.521 185.926 201.164C185.926 206.806 181.336 211.396 175.694 211.396ZM175.694 195.552C172.6 195.552 170.082 198.069 170.082 201.164C170.082 204.258 172.599 206.775 175.694 206.775C178.789 206.775 181.306 204.258 181.306 201.164C181.306 198.069 178.788 195.552 175.694 195.552Z"
        fill="#311F6E"
      />
      <path
        d="M154.732 228.805C154.64 228.805 154.548 228.8 154.454 228.787C153.187 228.635 152.283 227.485 152.435 226.218L154.235 211.232C154.418 209.712 153.833 208.21 152.671 207.214L149.193 204.231C146.879 202.247 145.7 199.253 146.04 196.223L148.157 177.354C148.299 176.086 149.443 175.178 150.71 175.315C151.978 175.458 152.891 176.6 152.749 177.869L150.633 196.738C150.464 198.246 151.05 199.735 152.202 200.722L155.68 203.705C158.016 205.708 159.192 208.728 158.825 211.783L157.025 226.769C156.882 227.943 155.885 228.805 154.732 228.805Z"
        fill="#311F6E"
      />
      <g opacity="0.2">
        <g opacity="0.2">
          <path
            opacity="0.2"
            d="M203.923 187.053C202.524 192.277 203.412 197.808 203.196 203.213C202.981 208.618 201.172 214.598 196.382 217.112C193.078 218.847 189.118 218.53 185.407 218.154C166.519 216.241 147.672 213.922 128.883 211.199C125.973 214.437 127.528 219.953 130.923 222.677C134.319 225.402 138.868 226.081 143.182 226.662C157.996 228.66 172.811 230.656 187.625 232.654C190.208 233.003 193.01 233.311 195.271 232.015C197.832 230.548 198.931 227.477 199.73 224.635C203.18 212.372 204.741 199.58 203.923 187.053Z"
            fill="#311F6E"
          />
        </g>
      </g>
      <g opacity="0.2">
        <g opacity="0.2">
          <path
            opacity="0.2"
            d="M282.758 186.515C282.821 190.232 280.497 193.883 277.103 195.398C273.708 196.913 269.439 196.206 266.714 193.677C265.33 192.392 264.313 190.378 265.034 188.634C265.578 187.32 266.94 186.55 268.263 186.026C272.979 184.157 278.428 184.219 282.758 186.515Z"
            fill="#311F6E"
          />
        </g>
      </g>
      <path
        d="M258.704 71.4658C258.704 71.4658 275.052 79.4353 276.505 82.7297C279.2 88.8373 275.475 122.944 265.735 131.034C261.921 134.202 235.943 135.111 235.943 135.111L258.704 71.4658Z"
        fill="white"
      />
      <path
        d="M235.943 135.113C235.943 135.113 261.921 134.202 265.733 131.033C269.534 127.878 272.424 120.751 274.364 112.875C274.056 113.105 264.27 120.103 247.634 102.537C247.625 102.526 247.612 102.516 247.604 102.506L235.943 135.113Z"
        fill="#E2E2E2"
      />
      <path
        d="M182.029 100.405L182.002 100.696L181.829 100.536L182.029 100.405Z"
        fill="#D8D8D8"
      />
      <path
        d="M181.83 100.536L181.632 100.662L181.658 100.371L181.83 100.536Z"
        fill="#D8D8D8"
      />
      <path
        d="M123.211 124.798C123.211 124.798 97.8307 119.189 94.6563 115.381C91.4903 111.588 89.943 104.055 89.4637 95.9582C89.4596 95.953 89.4596 95.953 89.4596 95.953C88.7072 83.3146 90.5391 69.2903 92.8306 65.9266C94.8571 62.951 112.38 58.0771 112.38 58.0771L117.662 90.6165L123.211 124.798Z"
        fill="white"
      />
      <path
        d="M123.211 124.798C123.211 124.798 97.8308 119.189 94.6565 115.381C91.4904 111.588 89.9431 104.055 89.4639 95.9581C89.7247 96.2396 98.0782 104.897 117.626 90.6413C117.637 90.633 117.651 90.6247 117.661 90.6165L123.211 124.798Z"
        fill="#D8D8D8"
      />
      <path
        d="M235.943 137.422C235.207 137.422 234.514 137.071 234.078 136.475C233.626 135.857 233.51 135.054 233.768 134.334L256.527 70.6886C256.749 70.0697 257.223 69.575 257.831 69.3276C258.44 69.0802 259.125 69.103 259.716 69.3907C264.86 71.8986 276.999 78.1272 278.618 81.7983C281.635 88.6366 277.943 123.9 267.211 132.813C263.109 136.221 242.303 137.203 236.024 137.422C235.997 137.422 235.97 137.422 235.943 137.422ZM260.003 74.6962L239.275 132.658C250.521 132.102 262.462 130.749 264.258 129.257C268.007 126.144 271.464 117.352 273.507 105.739C275.482 94.5061 275.289 85.7003 274.39 83.6634C273.559 82.2072 266.682 78.0992 260.003 74.6962Z"
        fill="#311F6E"
      />
      <path
        d="M123.213 127.108C123.047 127.108 122.88 127.091 122.714 127.054C116.58 125.698 96.2977 120.957 92.8822 116.862C83.946 106.149 86.7126 70.8014 90.9209 64.6245C93.1803 61.3073 106.248 57.3847 111.761 55.8518C112.393 55.6759 113.071 55.7773 113.626 56.1323C114.179 56.4863 114.555 57.0597 114.661 57.7076L125.494 124.427C125.617 125.182 125.357 125.95 124.801 126.476C124.367 126.887 123.797 127.108 123.213 127.108ZM110.517 61.0196C103.331 63.1537 95.8195 65.9493 94.7183 67.2565C93.4856 69.0677 91.6982 77.6914 91.603 89.0971C91.5046 100.888 93.3086 110.161 96.4312 113.903C97.9268 115.697 109.424 119.194 120.382 121.781L110.517 61.0196Z"
        fill="#311F6E"
      />
      <path
        d="M183.576 165.027C227.121 165.027 262.421 129.727 262.421 86.1817C262.421 42.6367 227.121 7.33643 183.576 7.33643C140.031 7.33643 104.73 42.6367 104.73 86.1817C104.73 129.727 140.031 165.027 183.576 165.027Z"
        fill="white"
      />
      <path
        d="M262.095 93.3635C258.128 136.728 219.758 168.665 176.394 164.698C133.03 160.731 101.088 122.361 105.056 78.9967C105.475 74.4178 106.276 69.9642 107.433 65.6731C110.421 103.221 140.067 134.287 178.852 137.835C217.638 141.384 252.423 116.212 262.176 79.8298C262.534 84.2596 262.514 88.7846 262.095 93.3635Z"
        fill="#D8D8D8"
      />
      <path
        d="M183.719 166.928C181.23 166.928 178.729 166.814 176.22 166.584C154.744 164.62 135.318 154.409 121.521 137.833C107.724 121.258 101.208 100.301 103.172 78.8248C105.137 57.3485 115.348 37.9216 131.924 24.125C148.499 10.3274 169.458 3.81212 190.932 5.77655C212.408 7.74098 231.834 17.9523 245.632 34.5278C259.429 51.1033 265.945 72.06 263.98 93.5363C262.016 115.013 251.804 134.439 235.229 148.236C220.589 160.422 202.532 166.928 183.719 166.928ZM183.441 9.22206C165.508 9.22206 148.3 15.4227 134.347 27.0365C118.549 40.1862 108.817 58.7013 106.945 79.1705C105.073 99.6397 111.283 119.613 124.432 135.41C137.582 151.208 156.097 160.941 176.565 162.813C197.035 164.687 217.008 158.475 232.805 145.326C248.603 132.176 258.335 113.661 260.208 93.1926L262.093 93.3655L260.208 93.1926C262.08 72.7234 255.87 52.75 242.72 36.9518C229.571 21.1535 211.055 11.4214 190.587 9.54912C188.197 9.33074 185.811 9.22206 183.441 9.22206Z"
        fill="#311F6E"
      />
      <path
        d="M183.719 166.928C181.23 166.928 178.729 166.814 176.22 166.584C154.744 164.62 135.318 154.409 121.521 137.833C107.724 121.258 101.208 100.301 103.172 78.8248C105.137 57.3485 115.348 37.9216 131.924 24.125C148.499 10.3274 169.458 3.81212 190.932 5.77655C212.408 7.74098 231.834 17.9523 245.632 34.5278C259.429 51.1033 265.945 72.06 263.98 93.5363C262.016 115.013 251.804 134.439 235.229 148.236C220.589 160.422 202.532 166.928 183.719 166.928ZM183.441 9.22206C165.508 9.22206 148.3 15.4227 134.347 27.0365C118.549 40.1862 108.817 58.7013 106.945 79.1705C105.073 99.6397 111.283 119.613 124.432 135.41C137.582 151.208 156.097 160.941 176.565 162.813C197.035 164.687 217.008 158.475 232.805 145.326C248.603 132.176 258.335 113.661 260.208 93.1926L262.093 93.3655L260.208 93.1926C262.08 72.7234 255.87 52.75 242.72 36.9518C229.571 21.1535 211.055 11.4214 190.587 9.54912C188.197 9.33074 185.811 9.22206 183.441 9.22206Z"
        fill="#311F6E"
      />
      <path
        d="M183.719 166.928C181.23 166.928 178.729 166.814 176.22 166.584C154.744 164.62 135.318 154.409 121.521 137.833C107.724 121.258 101.208 100.301 103.172 78.8248C105.137 57.3485 115.348 37.9216 131.924 24.125C148.499 10.3274 169.458 3.81212 190.932 5.77655C212.408 7.74098 231.834 17.9523 245.632 34.5278C259.429 51.1033 265.945 72.06 263.98 93.5363C262.016 115.013 251.804 134.439 235.229 148.236C220.589 160.422 202.532 166.928 183.719 166.928ZM183.441 9.22206C165.508 9.22206 148.3 15.4227 134.347 27.0365C118.549 40.1862 108.817 58.7013 106.945 79.1705C105.073 99.6397 111.283 119.613 124.432 135.41C137.582 151.208 156.097 160.941 176.565 162.813C197.035 164.687 217.008 158.475 232.805 145.326C248.603 132.176 258.335 113.661 260.208 93.1926L262.093 93.3655L260.208 93.1926C262.08 72.7234 255.87 52.75 242.72 36.9518C229.571 21.1535 211.055 11.4214 190.587 9.54912C188.197 9.33074 185.811 9.22206 183.441 9.22206Z"
        fill="#311F6E"
      />
      <path
        d="M183.631 167.339C181.162 167.339 178.679 167.227 176.181 166.999C139.362 163.631 109.494 135.856 103.498 99.4358C103.487 99.3861 103.477 99.3354 103.468 99.2836C102.368 92.5634 102.129 85.6682 102.758 78.7875C103.038 75.7384 103.488 72.709 104.097 69.782C112.39 29.2887 149.741 1.5962 190.969 5.36463C232.213 9.13721 263.917 43.1618 264.716 84.507C264.778 87.5033 264.67 90.5565 264.393 93.5767C263.765 100.447 262.281 107.184 259.984 113.602C259.967 113.652 259.947 113.7 259.926 113.749C248.26 146.118 217.562 167.338 183.631 167.339ZM108.04 98.5767C113.654 132.974 141.843 159.215 176.601 162.396C211.359 165.574 243.846 144.886 255.614 112.075C255.634 112.018 255.656 111.961 255.68 111.907C257.818 105.896 259.201 99.5879 259.79 93.1533C260.05 90.305 260.153 87.4256 260.095 84.597C259.341 45.6065 229.443 13.5235 190.547 9.96521C151.663 6.40274 116.442 32.5241 108.621 70.7145C108.046 73.478 107.622 76.3325 107.359 79.2077C106.77 85.6496 106.986 92.1028 108.004 98.3925C108.018 98.4536 108.031 98.5146 108.04 98.5767ZM262.091 93.3645H262.097H262.091Z"
        fill="#311F6E"
      />
      <path
        d="M261.241 74.4166C260.439 74.4166 259.701 73.9043 259.441 73.1105C249.673 43.1803 222.308 21.9152 189.728 18.9344C157.173 15.9526 126.406 31.8864 111.358 59.5199C110.883 60.3934 109.815 60.7494 108.911 60.3375C108.006 59.9256 107.574 58.8854 107.921 57.9539C120.583 23.919 154.719 2.46445 190.932 5.77542C227.169 9.09156 256.849 36.4042 263.108 72.1965C263.279 73.1746 262.665 74.1196 261.7 74.3597C261.547 74.399 261.393 74.4166 261.241 74.4166ZM181.955 14.7913C184.646 14.7913 187.351 14.9134 190.073 15.1629C214.543 17.4016 236.205 29.5142 250.27 47.7757C238.027 26.58 215.999 11.8726 190.587 9.54799C165.187 7.22235 140.86 17.6831 124.973 36.2976C140.211 22.6149 160.468 14.7913 181.955 14.7913Z"
        fill="#311F6E"
      />
      <path
        d="M262.088 93.3665C261.466 100.162 260.001 106.686 257.804 112.825C257.804 112.825 257.797 112.824 257.796 112.831C241.768 137.901 210.768 157.897 177.29 154.833C143.812 151.771 116.963 126.481 105.75 98.9193C105.751 98.9121 105.744 98.911 105.744 98.911C104.69 92.4754 104.432 85.7945 105.054 78.9987C105.327 76.0272 105.76 73.1075 106.353 70.2529C119.627 41.9136 152.49 23.5372 188.996 26.8771C225.509 30.2181 254.498 54.2684 262.401 84.5514C262.462 87.4598 262.359 90.4023 262.088 93.3665Z"
        fill="#311F6E"
      />
      <g opacity="0.35">
        <g opacity="0.35">
          <path
            opacity="0.35"
            d="M262.091 93.3686C261.469 100.164 260.004 106.688 257.807 112.827C257.807 112.827 257.8 112.826 257.799 112.833C241.771 137.903 210.771 157.897 177.293 154.834C143.816 151.772 116.966 126.484 105.753 98.9224C105.754 98.9151 105.747 98.9141 105.747 98.9141C105.121 95.0794 104.777 91.1619 104.729 87.1772C120.524 108.565 144.805 125.296 173.302 127.903C209.607 131.225 243.363 110.766 262.296 84.1602C262.334 84.2937 262.373 84.421 262.404 84.5535C262.466 87.4618 262.362 90.4054 262.091 93.3686Z"
            fill="#111A28"
          />
        </g>
      </g>
      <path
        d="M184.072 157.036C181.749 157.036 179.43 156.93 177.119 156.719C161.01 155.245 145.396 148.608 131.967 137.524C119.806 127.487 109.89 114.066 104.036 99.7266C103.96 99.5682 103.906 99.3975 103.876 99.2174C102.781 92.5313 102.543 85.6702 103.17 78.8258C103.448 75.7932 103.896 72.7793 104.501 69.8668C104.532 69.723 104.578 69.5822 104.641 69.4487C111.411 54.9949 122.972 43.0883 138.073 35.0142C153.431 26.8036 171.102 23.3394 189.172 24.9903C207.245 26.6442 223.995 33.262 237.612 44.1295C251 54.8138 260.206 68.6259 264.237 84.0722C264.274 84.2161 264.295 84.363 264.298 84.511C264.359 87.497 264.252 90.5337 263.976 93.5373C263.351 100.372 261.875 107.075 259.59 113.461C259.528 113.634 259.443 113.793 259.34 113.936C250.982 126.975 238.794 138.371 225.011 146.036C211.972 153.285 197.951 157.035 184.072 157.036ZM107.579 98.3831C117.795 123.324 143.331 149.825 177.465 152.947C211.603 156.073 241.526 134.643 256.099 111.972C258.233 105.951 259.614 99.6345 260.204 93.1937C260.459 90.4064 260.564 87.5881 260.515 84.8143C252.487 54.4681 223.709 31.9548 188.827 28.7639C153.953 25.573 121.57 42.4807 108.165 70.8563C107.612 73.5607 107.201 76.3573 106.943 79.1725C106.352 85.6216 106.566 92.0831 107.579 98.3831Z"
        fill="#311F6E"
      />
      <g opacity="0.5">
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M249.981 92.7821C251.875 85.3712 249.057 78.251 243.687 76.8787C238.317 75.5064 232.428 80.4017 230.535 87.8126C228.641 95.2235 231.459 102.344 236.829 103.716C242.199 105.088 248.087 100.193 249.981 92.7821Z"
            fill="white"
          />
        </g>
      </g>
      <g opacity="0.5">
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M231.087 118.882C232.418 115.633 231.237 112.074 228.45 110.932C225.662 109.79 222.324 111.498 220.993 114.746C219.662 117.995 220.843 121.554 223.63 122.696C226.417 123.838 229.756 122.13 231.087 118.882Z"
            fill="white"
          />
        </g>
      </g>
      <g opacity="0.5">
        <g opacity="0.5">
          <path
            opacity="0.5"
            d="M120.372 104.085C120.372 104.085 110.704 63.3858 133.288 49.0469C155.872 34.708 186.735 36.9674 185.872 38.8956C185.872 38.8956 151.111 44.7382 135.82 70.8036C124.026 90.9033 120.372 104.085 120.372 104.085Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2508_19648">
        <rect width="425" height="427" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
